import reviewsDb from "../../../data/reviewsDb";
import Rating from "../../ui/Rating/Rating";
import s from "./Reviews.module.scss";

function Reviews() {
  const { title, items } = reviewsDb;

  return (
    <section className={s.reviews} id="reviews">
      <div className={`container ${s.container}`}>
        <h2 className={s.title}>{title}</h2>

        <div className={s.grid}>
          {items.map((item) => (
            <div key={item.id} className={s.card}>
              <img
                src={item.image}
                alt={item.name}
                className={s.avatar}
              />
              <p className={s.text}>{item.text}</p>

              <Rating value={item.rating} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;
